/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanUnit } from './PlanUnit';
import {
    PlanUnitFromJSON,
    PlanUnitFromJSONTyped,
    PlanUnitToJSON,
    PlanUnitToJSONTyped,
} from './PlanUnit';

/**
 * 
 * @export
 * @interface TrainingPlan
 */
export interface TrainingPlan {
    /**
     * 
     * @type {string}
     * @memberof TrainingPlan
     */
    creatorId: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlan
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrainingPlan
     */
    viewerIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlan
     */
    title: string;
    /**
     * 
     * @type {Array<PlanUnit>}
     * @memberof TrainingPlan
     */
    units: Array<PlanUnit>;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingPlan
     */
    unlockMode: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingPlan
     */
    allowUsersToRateWorkout: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlan
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingPlan
     */
    trainingDateIso?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrainingPlan
     */
    editorIds: Array<string>;
}

/**
 * Check if a given object implements the TrainingPlan interface.
 */
export function instanceOfTrainingPlan(value: object): value is TrainingPlan {
    if (!('creatorId' in value) || value['creatorId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('viewerIds' in value) || value['viewerIds'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('units' in value) || value['units'] === undefined) return false;
    if (!('unlockMode' in value) || value['unlockMode'] === undefined) return false;
    if (!('allowUsersToRateWorkout' in value) || value['allowUsersToRateWorkout'] === undefined) return false;
    if (!('editorIds' in value) || value['editorIds'] === undefined) return false;
    return true;
}

export function TrainingPlanFromJSON(json: any): TrainingPlan {
    return TrainingPlanFromJSONTyped(json, false);
}

export function TrainingPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingPlan {
    if (json == null) {
        return json;
    }
    return {
        
        'creatorId': json['creatorId'],
        'id': json['id'],
        'viewerIds': json['viewerIds'],
        'title': json['title'],
        'units': ((json['units'] as Array<any>).map(PlanUnitFromJSON)),
        'unlockMode': json['unlockMode'],
        'allowUsersToRateWorkout': json['allowUsersToRateWorkout'],
        'description': json['description'] == null ? undefined : json['description'],
        'trainingDateIso': json['trainingDateIso'] == null ? undefined : json['trainingDateIso'],
        'editorIds': json['editorIds'],
    };
}

export function TrainingPlanToJSON(json: any): TrainingPlan {
    return TrainingPlanToJSONTyped(json, false);
}

export function TrainingPlanToJSONTyped(value?: TrainingPlan | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creatorId': value['creatorId'],
        'id': value['id'],
        'viewerIds': value['viewerIds'],
        'title': value['title'],
        'units': ((value['units'] as Array<any>).map(PlanUnitToJSON)),
        'unlockMode': value['unlockMode'],
        'allowUsersToRateWorkout': value['allowUsersToRateWorkout'],
        'description': value['description'],
        'trainingDateIso': value['trainingDateIso'],
        'editorIds': value['editorIds'],
    };
}

